// ./client/src/Layout/Footer.js
import React from 'react'

export default function Footer() {
	return (
      <footer className="text-gray-600 text-xs max-w-5xl mx-auto text-center px-4 pt-24 pb-8">
          <p>
            &copy; 2022. App de <a className="underline" href="https://escuelafrontend.com">Escuela Frontend</a> desarrollada por <a className="underline" href="https://twitter.com/mikenieva">@mikenieva</a>.
          </p>
          <p>
            Tienda electrónica ficticia con objetivos de aprendizaje.
          </p>
          <p>
          Vector (Logo) de Comida fue creado por catalyststuff <a className="underline" href='https://www.freepik.es/vectores/comida'>www.freepik.es</a>
          </p>
      </footer>
	)
}
